var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"d-flex flex-column",attrs:{"id":"app"}},[_c('div',{staticClass:"page-content"},[(_vm.$router.history.current.path !== '/login')?_c('Header'):_vm._e(),_vm._v(" "),_c('div',{staticClass:"page-content mb-3"},[_c('router-view')],1)],1),_vm._v(" "),(_vm.$router.history.current.path !== '/login')?_c('Footer',{staticClass:"sticky-footer"}):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-f25e2e7c","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = null
// module chunks = 